import ufeApi from 'services/api/ufeApi';
import urlUtils from 'utils/Url';
import userUtils from 'utils/User';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Purchase+History

function getPurchaseHistory(profileId, options) {
    const biAccountId = userUtils.getBiAccountId();
    const nonBiAccountResponse = {
        activities: [],
        meta: { totalItems: 0 },
        purchasedGroups: [],
        purchasedItemsCount: 0,
        purchasedItems: []
    };
    let url = '';
    let isRewardsFilter = false;

    if (options) {
        const {
            sortBy, itemsPerPage, currentPage, groupBy, excludeSamples, purchaseFilter, excludeRewards, includeNonBiUserPurchases
        } = options;

        isRewardsFilter = purchaseFilter === 'rewards';

        url = isRewardsFilter ? `/gway/v1/lxs/${biAccountId}/redemption-history` : `/api/bi/profiles/${profileId}/purchases`;

        const qsParams = {
            sortBy,
            itemsPerPage,
            currentPage,
            groupBy,
            excludeSamples,
            purchaseFilter,
            excludeRewards,
            includeNonBiUserPurchases
        };

        const qs = urlUtils.makeQueryString(qsParams);

        if (qs) {
            url += '?' + qs;
        }
    }

    const headers = {
        'x-requested-source': 'web'
    };

    if (isRewardsFilter && !biAccountId) {
        return Promise.resolve(nonBiAccountResponse);
    }

    return ufeApi.makeRequest(url, { method: 'GET', headers }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getPurchaseHistory;
